import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from '../components/AppShell';
import ConnectTab from '../components/dash/ConnectTab';
import { useMe, useFlash } from '../lib/useMe';

export default function ConnectPage() {
  const [me] = useMe();
  const flash = useFlash();
  const navigate = useNavigate();
  if (!me) return <AppShell title="Connect"><p style={{ color: 'var(--muted)' }}>Loading…</p></AppShell>;
  return (
    <AppShell
      title="Connect"
      subtitle="Members who are live on Krysha right now — matched on your vibe, not on swipes."
      testid="connect-page"
    >
      <ConnectTab me={me} flash={flash} go={(path, opts) => navigate(path, opts)} />
    </AppShell>
  );
}
